import script from "./PreInscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreInscription.vue?vue&type=script&setup=true&lang=ts"

import "./PreInscription.vue?vue&type=style&index=0&id=4a135de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a135de8"]])

export default __exports__